
import Cookies from "js-cookie"
import { translate } from "@/plugins/i18n"
import {
  frameworkStartedDefer,
  reSetLogin,
  resetLocal,
  getSubdomain,
  getLoginStatus,
  setCookies,
  openPop
} from "@/utils/utils"
import { logOut } from "@/api/auth"
import { getValidCouponList } from "@/api/coupon"
import { cardList } from "@/api/pay"
import storage from "@/utils/storage"

const routes = [
  "/cards",
  "/coupons",
  "/order_list",
  "/order_details",
  "/payment_result",
  "/pending_payment",
  "/cart",
  "/checkout",
  "/receipt"
]

export default {
  name: "Top",
  components: {},
  data() {
    return {
      lang: "",
      langList: [
        {
          name: "EN",
          lang: "en_US"
        },
        {
          name: "繁中",
          lang: "zh_HK"
        }
      ],
      accountList: [
        {
          type: "myCards",
          alias: "cards"
        },
        {
          type: "myCoupons",
          alias: "coupons"
        },
        {
          type: "myOrders",
          alias: "order_list"
        },
        {
          type: "logout"
        }
      ],
      langListShow: false,
      isOnline: false,
      accountListShow: false,
      popContent: {},
      accountInfo: {},
      memberPointsAvailable: 0,
      memberPointEquivalent: 0,
      couponCount: 0,
      cardCount: 0,
      showLogin: false,
      showLoginAndregister: false,
      showLogined: false,
      customerShow: false
    }
  },

  computed: {
    storeLocatorLink() {
      return this.$t("footer.storeLocatorLink")
    }
  },
  created() {},
  async mounted() {
    this.lang = this.$i18n.locale
    await this.$store.dispatch("getLoginInfo")
    const { isOnline } = getLoginStatus()
    this.isOnline = isOnline
    this.showLogined = !!isOnline
    this.showLoginAndregister = !isOnline
    if (this.isOnline) {
      const accountInfo = storage.get("accountInfo", { useBase64: true }) || {}
      this.accountInfo = accountInfo
      if (this.accountInfo && this.accountInfo.pointVo) {
        this.memberPointsAvailable = this.accountInfo.pointVo.memberPointsAvailable
        this.memberPointEquivalent = this.accountInfo.pointVo.memberPointEquivalent
      }
      this.getCouponCount()
      this.getCardCount()
    }
    if (process.env.VUE_APP_LOGIN_SHOW == "true") {
      this.showLogin = true
    }
  },

  methods: {
    async getCouponCount() {
      const params = {}
      const { data: res } = await getValidCouponList({ param: JSON.stringify(params) })
      this.couponCount = res.count || 0
    },
    async getCardCount() {
      try {
        const { data } = await cardList({
          params: JSON.stringify({
            payWay: 800
          })
        })
        this.cardCount = data ? data.length : 0
      } catch (error) {
        console.log(error)
      }
    },
    handleChangeLanguage(item) {
      const lang = this.$i18n.locale
      if (item.lang === lang) {
        this.langListShow = false
        return
      }
      let href = window.location.href

      if (lang === "zh_HK") {
        setCookies("superweb-locale", "en_US")
        this.$i18n.locale = "en_US"
        this.langListShow = false
        if (href.includes("/zh-hant")) {
          href = href.replace("/zh-hant", "/en")
          // this.$navigation.push(href)
          window.location.href = href
        } else {
          window.location.reload()
        }
      } else {
        setCookies("superweb-locale", "zh_HK")
        this.$i18n.locale = "zh_HK"
        this.langListShow = false
        if (href.includes("/en")) {
          href = href.replace("/en", "/zh-hant")
          // this.$navigation.push(href)
          window.location.href = href
        } else {
          window.location.reload()
        }
      }
    },
    openPop() {
      openPop()
    },
    handleLangHover() {
      this.langListShow = true
    },
    handleLangOut() {
      this.langListShow = false
    },
    handleAccountHover() {
      this.accountListShow = true
    },
    handleAccountOut() {
      this.accountListShow = false
    },
    handleCustomerHover() {
      this.customerShow = true
    },
    handleCustomerOut() {
      this.customerShow = false
    },
    async logOutFun() {
      const url = window.location.href
      let redirect = false

      const _this = this

      const res = await logOut().catch(resE => {
        this.$message({
          type: "info",
          message: translate("common.logoutfailed") + "：" + resE
        })
      })
      console.log("logout:", res)
      if (res.data == 0) {
        reSetLogin()
        this.$message({
          type: "info",
          message: translate("common.logoutSuccess")
        })
        routes.forEach(item => {
          if (url.includes(item)) {
            redirect = true
          }
        })
        setTimeout(() => {
          if (redirect) {
            window.location.href = `${_this.MAIN_ORIGIN_HOME}`
          } else {
            window.location.reload()
          }
        }, 1000)
      }
    },
    handleLogOut() {
      this.popContent = {
        title: translate("common.logOutTips"),
        message: translate("common.logOutMsg"),
        cancelText: translate("common.no"),
        confirmText: translate("common.yes")
      }
      this.$refs.messageBox.open()
    },
    goItem(item) {
      if (item.type === "logout") {
        this.handleLogOut()
      } else {
        if (item.type === "accountSetting") {
          const url = item[`url_${this.lang}`]
          if (url) {
            window.open(url)
          }
        } else {
          this.$navigation.push({
            path: "/" + item.alias
          })
        }
        this.handleAccountOut()
      }
    },
    handleJumpWellComeCenter() {
      return this.$t("header.customerCareLink")
    },
    goFeedback() {
      const link = this.$t("header.feedbackLink")
      window.open(link)
    }
  }
}
